import React from "react";

const About: React.FC = () => {
  return <div>Contact at bentucker333@gmail.com to purchase a print or if you have any questions.</div>;
};

export default About;
